export const iconFontAwesomeEnergyCarBattery = (
	<i className="fa-solid fa-car-battery"></i>
);
